module.exports = __webpack_public_path__ + "c5458b9039c4bcc3c329e2a23fc79127.svg";